








var jspb=require('google-protobuf');
var goog=jspb;
var global=Function('return this')();

var mti_metadata_pb=require('../mti/metadata_pb.js');
goog.exportSymbol('proto.mti.ResourceUpdated',null,global);
goog.exportSymbol('proto.mti.ResourceUpdated.Action',null,global);
goog.exportSymbol('proto.mti.ResourceUpdated.Context',null,global);











proto.mti.ResourceUpdated=function(opt_data){
jspb.Message.initialize(this,opt_data,0,-1,null,null);
};
goog.inherits(proto.mti.ResourceUpdated,jspb.Message);
if(goog.DEBUG&&!COMPILED){
proto.mti.ResourceUpdated.displayName='proto.mti.ResourceUpdated';
}


if(jspb.Message.GENERATE_TO_OBJECT){










proto.mti.ResourceUpdated.prototype.toObject=function(opt_includeInstance){
return proto.mti.ResourceUpdated.toObject(opt_includeInstance,this);
};











proto.mti.ResourceUpdated.toObject=function(includeInstance,msg){
var f,obj={
metadata:(f=msg.getMetadata())&&mti_metadata_pb.Metadata.toObject(includeInstance,f),
storeId:jspb.Message.getFieldWithDefault(msg,2,0),
context:jspb.Message.getFieldWithDefault(msg,3,0),
contextId:jspb.Message.getFieldWithDefault(msg,4,0),
action:jspb.Message.getFieldWithDefault(msg,5,0)};


if(includeInstance){
obj.$jspbMessageInstance=msg;
}
return obj;
};
}







proto.mti.ResourceUpdated.deserializeBinary=function(bytes){
var reader=new jspb.BinaryReader(bytes);
var msg=new proto.mti.ResourceUpdated();
return proto.mti.ResourceUpdated.deserializeBinaryFromReader(msg,reader);
};









proto.mti.ResourceUpdated.deserializeBinaryFromReader=function(msg,reader){
while(reader.nextField()){
if(reader.isEndGroup()){
break;
}
var field=reader.getFieldNumber();
switch(field){
case 1:
var value=new mti_metadata_pb.Metadata();
reader.readMessage(value,mti_metadata_pb.Metadata.deserializeBinaryFromReader);
msg.setMetadata(value);
break;
case 2:
var value=reader.readUint64();
msg.setStoreId(value);
break;
case 3:
var value=reader.readEnum();
msg.setContext(value);
break;
case 4:
var value=reader.readUint64();
msg.setContextId(value);
break;
case 5:
var value=reader.readEnum();
msg.setAction(value);
break;
default:
reader.skipField();
break;}

}
return msg;
};






proto.mti.ResourceUpdated.prototype.serializeBinary=function(){
var writer=new jspb.BinaryWriter();
proto.mti.ResourceUpdated.serializeBinaryToWriter(this,writer);
return writer.getResultBuffer();
};









proto.mti.ResourceUpdated.serializeBinaryToWriter=function(message,writer){
var f=undefined;
f=message.getMetadata();
if(f!=null){
writer.writeMessage(
1,
f,
mti_metadata_pb.Metadata.serializeBinaryToWriter);

}
f=message.getStoreId();
if(f!==0){
writer.writeUint64(
2,
f);

}
f=message.getContext();
if(f!==0.0){
writer.writeEnum(
3,
f);

}
f=message.getContextId();
if(f!==0){
writer.writeUint64(
4,
f);

}
f=message.getAction();
if(f!==0.0){
writer.writeEnum(
5,
f);

}
};





proto.mti.ResourceUpdated.Context={
STORE:0,
STORE_RULE:1,
SECURITY_DEVICE:2,
FIXTURE:3,
FIXTURE_RULE:4,
POSITION:5,
POSITION_RULE:6,
PRODUCT:7,
SECURED_PRODUCT:8,
RULE:9};





proto.mti.ResourceUpdated.Action={
CREATED:0,
UPDATED:1,
DELETED:2};






proto.mti.ResourceUpdated.prototype.getMetadata=function(){
return(
jspb.Message.getWrapperField(this,mti_metadata_pb.Metadata,1));
};



proto.mti.ResourceUpdated.prototype.setMetadata=function(value){
jspb.Message.setWrapperField(this,1,value);
};


proto.mti.ResourceUpdated.prototype.clearMetadata=function(){
this.setMetadata(undefined);
};






proto.mti.ResourceUpdated.prototype.hasMetadata=function(){
return jspb.Message.getField(this,1)!=null;
};






proto.mti.ResourceUpdated.prototype.getStoreId=function(){
return jspb.Message.getFieldWithDefault(this,2,0);
};



proto.mti.ResourceUpdated.prototype.setStoreId=function(value){
jspb.Message.setProto3IntField(this,2,value);
};






proto.mti.ResourceUpdated.prototype.getContext=function(){
return jspb.Message.getFieldWithDefault(this,3,0);
};



proto.mti.ResourceUpdated.prototype.setContext=function(value){
jspb.Message.setProto3EnumField(this,3,value);
};






proto.mti.ResourceUpdated.prototype.getContextId=function(){
return jspb.Message.getFieldWithDefault(this,4,0);
};



proto.mti.ResourceUpdated.prototype.setContextId=function(value){
jspb.Message.setProto3IntField(this,4,value);
};






proto.mti.ResourceUpdated.prototype.getAction=function(){
return jspb.Message.getFieldWithDefault(this,5,0);
};



proto.mti.ResourceUpdated.prototype.setAction=function(value){
jspb.Message.setProto3EnumField(this,5,value);
};


goog.object.extend(exports,proto.mti);